import { Label } from '@procurify/ui'

import { UnbilledItemPOLabel } from '@webapp/components/UnbilledItemPOLabel'
import { BridgeLink } from '@webapp/core/components/BridgeLink'
import { useFeatureFlag } from '@webapp/hooks'
import { type ColumnTypeData } from '../../types/DataTable.types'

export const UnbilledItemRefCell = ({
  item,
}: {
  item: ColumnTypeData['UNBILLEDITEM_REF']
}) => {
  const ARCH_531_MIGRATION_EXPENSE_DETAILS = useFeatureFlag(
    'ARCH_531_MIGRATION_EXPENSE_DETAILS'
  )

  if (item?.po?.number) {
    return (
      <div onClick={(e) => e.stopPropagation()}>
        <BridgeLink to={`/#/purchase/order/details/${item.po.uuid}`}>
          <UnbilledItemPOLabel
            poNumber={item.po.number}
            orderItem={item.orderitem}
          />
        </BridgeLink>
      </div>
    )
  }

  if (item?.expense_report?.id) {
    const expenseDetailUrl = ARCH_531_MIGRATION_EXPENSE_DETAILS
      ? `/expenses/${item.expense_report.uuid}`
      : `/#/expenses/${item.expense_report.uuid}`

    return (
      <BridgeLink to={expenseDetailUrl} onClick={(e) => e.stopPropagation()}>
        <Label label='RFE'>{item.expense_report.id}</Label>
      </BridgeLink>
    )
  }

  return null
}

UnbilledItemRefCell.displayName = 'UnbilledItemRefCell'
